import * as React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="30563" id="welcome-banner" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-[radial-gradient(circle_at_top_right,var(--color-secondary)_0%,var(--color-background)_70%)] px-6 py-24 sm:px-12 lg:px-24">
      <div ref={ref} className={cn("relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
        {}
        <Badge variant="outline" className="mb-8 border-chart-2/30 bg-chart-2/5 px-4 py-1.5 text-sm font-medium tracking-widest text-chart-2 uppercase backdrop-blur-sm">
          A Sanctuary for Expression
        </Badge>

        {}
        <h1 className="mb-8 font-serif text-6xl font-black leading-tight tracking-tight text-primary sm:text-7xl md:text-8xl lg:text-9xl">
          Your Story <br className="hidden md:block" />
          <span className="text-chart-2">Matters</span>
        </h1>

        {}
        <div className="mb-10 flex max-w-[600px] flex-col gap-6 text-lg leading-relaxed text-primary/80 md:text-xl">
          <p>
            The Story Haven provides a safe, guided space for children and
            caregivers to express life experiences through storytelling,
            creative arts, and gentle movement.
          </p>
          <p>
            We believe every voice deserves to be heard. Our programs help
            families discover hope, healing, and emotional resilience through
            the power of creative expression.
          </p>
        </div>

        {}
        <div className="mt-4">
          <Button asChild size="lg" className="h-14 min-w-[240px] rounded-full bg-chart-2 px-8 text-lg font-bold text-primary shadow-xl shadow-chart-2/20 transition-all hover:bg-chart-2/90 hover:shadow-chart-2/40 hover:-translate-y-1">
            <Link to="/ShareYourStoryPage">Start Your Submission</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.05] bg-[url('https://grainy-gradients.vercel.app/noise.svg')] mix-blend-overlay" />
    </section>;
}